import { HypothekenRenteoverzichtComponent } from '@io/hypotheken-renteoverzicht.component';
import { contentInitializer } from '@io/content.initializer';

import localeNl from '@angular/common/locales/nl';
import { enableProdMode, importProvidersFrom, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';

import { ApAnalyticsModule } from '@ap/analytics';
import { ApContentService } from '@ap/content';
import { ApFormService } from '@ap/form';
import { MortgageInterestRateResource } from '@ap/ap-interface-apix-rs-hypotheken-renteoverzicht';
import { ApErrorService } from '@ap/error';

// @ts-ignore: Needs to be ignored so the typescript compiler replaces CONFIGURATION
export const configuration: string = CONFIGURATION;

registerLocaleData(localeNl, 'nl');

if (configuration !== 'development') {
    enableProdMode();
}

document.addEventListener('DOMContentLoaded', () => {
    bootstrapApplication(HypothekenRenteoverzichtComponent, {
        providers: [
            provideZoneChangeDetection(),
            provideAppInitializer(contentInitializer),
            importProvidersFrom(ApAnalyticsModule),
            provideHttpClient(),
            ApContentService,
            ApFormService,
            MortgageInterestRateResource,
            ApErrorService
        ]
    }).catch((err) => console.error(err));
});
